exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#builder-menu{z-index:2;background:#f8e99d;box-shadow:0 0 11px -6px rgba(0,0,0,.8)}#builder-menu span{font-family:ibm-plex-mono,sans-serif;text-transform:uppercase;font-size:17px;padding-top:9px;margin-top:5px}#builder-menu span.badge{padding:8px 10px;font-size:13px}#builder-menu .btn-outline-dark{min-width:150px;border-radius:100px;text-transform:uppercase;font-family:ibm-plex-mono,sans-serif;padding:3px 5px 6px;border-width:2px;font-weight:700}#builder-menu .btn-white{background:#fff;color:#000;border-radius:200px;padding:6px 10px}#builder-menu .btn-white.active{background:#000;color:#fff}", ""]);

// exports
